<div *ngIf="canvasId">
  <h4 style="text-align: center; margin-bottom: -3px">
    <b>{{ data.title }}</b>
  </h4>
  <canvas [id]="canvasId">
    {{ graph }}
  </canvas>
</div>
